import {
  ClockStationService,
  ControlBlocksService,
  ClockStation_UpdateClockSystemSerialNumberModel,
  ClockStation_UpdateSerialNumberModel,
  ControlBlock_UsbModemLocationModel,
  GetEspConnections_GetEspConnectionsResponse,
  GetClockStationWarranty_GetClockStationWarrantyResponse,
  OpenAPI,
  UpdateDescriptionModel,
  UpdatePrivateDescriptionModel,
  UsbModemLocation,
} from "../api";
import {request} from "../api/generated/core/request";

export type ControlBlockWarrantyPayload = {
  daysUntilEndOfWarranty: number;
};

export type ControlBlockMaintenancePayload = {
  daysUntilMaintenance: number;
};

export type ClockStationWarrantyPayload = {
  daysUntilMaintenance: number;
  daysUntilEndOfWarranty: number;
};

export const SystemSettingsApi = {
  // Обновление описания
  updateDescription: async (id: string, description: string): Promise<boolean> => {
    const payload: UpdateDescriptionModel = {description};
    await ControlBlocksService.putApiControlBlocksDescription(id, payload);
    return true;
  },

  // Обновление описания (админ)
  updatePrivateDescription: async (id: string, privateDescription: string): Promise<boolean> => {
    const payload: UpdatePrivateDescriptionModel = {privateDescription};
    await ControlBlocksService.putApiControlBlocksDescriptionPrivate(id, payload);
    return true;
  },

  // удалить устройство
  deleteDevice: async (id: string): Promise<boolean> => {
    await ControlBlocksService.deleteApiControlBlocks(id);
    return true;
  },

  // Просмотр логов UArt
  updateDebugOutput: async (id: string, enabled: boolean): Promise<boolean> => {
    await ControlBlocksService.postApiControlBlocksDebugOutput(id, {enabled});
    return true;
  },

  //Обновление серийного номера
  updateSerialNumber: async (id: string, serialNumber: string) => {
    const payload: ClockStation_UpdateSerialNumberModel = {serialNumber};
    await ClockStationService.putApiClockStationSerialNumber(id, payload);
    return true;
  },


  //Обновление серийного номера
  updateSystemSerialNumber: async (id: string, clockSystemSerialNumber: string) => {
    const payload: ClockStation_UpdateClockSystemSerialNumberModel = {clockSystemSerialNumber};
    await ClockStationService.putApiClockStationClockSystemSerialNumber(id, payload);
    return true;
  },

  getClockStationWarranty: async (id: string): Promise<GetClockStationWarranty_GetClockStationWarrantyResponse> => {
    return ClockStationService.getApiClockStationWarranty(id);
  },

  updateClockStationWarranty: async (id: string, payload: ClockStationWarrantyPayload): Promise<boolean> => {
    await ClockStationService.postApiClockStationWarranty(id, payload);
    return true;
  },

  // Обновление срока гарантии БКС
  updateWarranty: async (id: string, payload: ControlBlockWarrantyPayload): Promise<boolean> => {
    await request<void>(OpenAPI, {
      method: "PUT",
      url: "/api/ControlBlocks/{id}/warranty",
      path: {id},
      body: payload,
      mediaType: "application/json"
    });
    return true;
  },

  // Обновление срока технического обслуживания БКС
  updateMaintenance: async (id: string, payload: ControlBlockMaintenancePayload): Promise<boolean> => {
    await request<void>(OpenAPI, {
      method: "PUT",
      url: "/api/ControlBlocks/{id}/maintenance",
      path: {id},
      body: payload,
      mediaType: "application/json"
    });
    return true;
  },

  // Получение параметров USB модема
  getUsbModemParams: async (id: string): Promise<GetEspConnections_GetEspConnectionsResponse> => {
    return ControlBlocksService.getApiControlBlocksConnections(id);
  },

  //Обновление места подключения модема
  updateUsbModemLocation: async (id: string, usbModemLocation: UsbModemLocation) => {
    const payload: ControlBlock_UsbModemLocationModel = {usbModemLocation};
    await ControlBlocksService.postApiControlBlocksConnectionsModemLocation(id, payload);
    return true;
  },
}
